// ---------------------------------
// Ebben a fájlban NE használj JSX-et, ugyanis ez egy generikus modul.
// ---------------------------------

import makeErrorElem                    from './makeErrorElem'
import getErrorsElement                 from './getErrorsElement'
import makeRuntimeErrorContent          from './makeRuntimeErrorContent'
import makeUnhandledPromiseErrorContent from './makeUnhandledPromiseErrorContent'

type TErrorType = 'runtime' | 'unhandledpromise'

// Hogy teljesen biztosak legyünk, hogy ilyen ID-t más nem csinált.
const ERROR_CONTAINER_ID = `error-container-${ Date.now() }`

const DEFAULT_TITLE = 'Futásidejű hiba!'

/**
 * Automatikusan az window "error" eseményére kötjük és futásidejű hibákat kirakunk
 * teljes képernyőre.
 *
 * Azért lett exportálva az errort dobó függvény, hogy Promise-okban is könnyen
 * meghívható legyen catch ágban és ne kelljen lefolyatni a legelső Promise-ig.
 * @param data    - Bármi lehet.
 * @param errType - A hibatípus.
 * @param title   - A hibajelzés címe.
 */
export default function errorModal (data: unknown, errType: TErrorType, title = DEFAULT_TITLE): void {
  /*
  // Ezt NE töröld ki attól még, hogy ki van kommentezve!
  // NEM DEAD CODE!
  // Webpack és egyéb szar pluginjai miatt előforduló hiba HMR-nél.
  if (
    e.message === 'TypeError: currentUpdate is undefined' ||
    // @ts-expect-error VAN stack, rohadj meg!
    e?.stack?.contains('webpackHotUpdate')
  ) {
    window.location.reload()
  }
  */

  let errors = getErrorsElement(ERROR_CONTAINER_ID)

  if (!errors) {
    const elem = makeErrorElem()

    elem.innerHTML = `
      <h1 style="color:#f00">${ title }</h1>
      <div id="${ ERROR_CONTAINER_ID }" style="padding: 25px;"></div>
    `

    document.body.appendChild(elem)

    errors = getErrorsElement(ERROR_CONTAINER_ID)
  }

  const content = errType === 'runtime'
    ? makeRuntimeErrorContent(data)
    : makeUnhandledPromiseErrorContent(data as PromiseRejectionEvent)

  if (errors) {
    // eslint-disable-next-line no-restricted-syntax -- Tartsuk vékonyan a modult, nem kell a dom utility.
    errors.prepend(content)
  }
  else {
    const elem     = makeErrorElem()
    elem.innerHTML = content.innerHTML

    document.body.appendChild(elem)
  }
}
